import request from '../../utils/request'
import config from '../../config/config'
const baseURL = config.baseURL;

export function menuOrdersList (data) {
  return request({
    url: baseURL + '/api/mealOrders/orderList',
    method: 'post',
    data: data
  })
}

export function menuOrdersAdd (data) {
  return request({
    url: baseURL + '/api/mealOrders/add', 
    method: 'post',
    data: data
  })
}

export function menuOrdersUpdate (data) {
  return request({
    url: baseURL + '/api/menuOrders/update',
    method: 'post',
    data: data
  })
}

export function menuOrdersDelete (data) {
  return request({
    url: baseURL + '/api/menuOrders/delete',
    method: 'post',
    data: data
  })
}

// 获取报餐人员详细记录
export function getOrderDetail (data) {
  return request({
    url: baseURL + '/api/mealOrders/orderDetail',
    method: 'post',
    data: data
  })
}
// 获取报餐人员详细记录
export function getDateOrderDetail (data) {
  return request({
    url: baseURL + '/api/mealOrders/dateOrderDetail',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/menuOrders/index.js